import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useMachine } from '@xstate/react';
import mainMachine from '../../machines/mainMachine';
const useMainMachine = ({ apiConfig, featureFlags, handleClose, handleCloseOnConversion, helpNumber, isOpen, triggerAnalyticsEvent }) => {
    const queryClient = useQueryClient();
    const mainMachineRef = useRef(mainMachine.withContext({
        apiConfig,
        conversionCount: 0,
        currentPaymentFlow: [null, null],
        featureFlags,
        handleClose,
        handleCloseOnConversion,
        helpNumber,
        queryClient,
        triggerAnalyticsEvent
    }));
    const [state, send, service] = useMachine(mainMachineRef.current, {
        devTools: process.env.NODE_ENV !== 'production'
    });
    useEffect(() => {
        if (!isOpen && state.matches('open')) {
            send({
                type: 'CANCEL'
            });
        }
    }, [isOpen, state, send]);
    return [state, send, service];
};
export default useMainMachine;
